import React from 'react'
import {Dashboard, Groups2Outlined} from "@mui/icons-material"
import SignInController from './pages/signin/SignInController'
import { Navigate } from 'react-router-dom'
import NotAllowedComponent from '../src/components/layouts/NotAllowedComponent'
import { getDefaultRedirect } from './utils/routinghelper'
import AppContainer from './components/layouts/common/AppContainer'
import MODULES from './utils/module.constant'
import PagenotFound from './components/layouts/PagenotFound'
import ListController from './pages/user/UserLIstController';
import PatientListController from './pages/patient/ListController'
import HearingTestController from './pages/hearingTest/HearingTestController'
import TinnitusTestApp from './pages/hearingTest/HearingTestController'
import PatientHearingDetails from './pages/hearingTest/PatientHearingDetails'
import MaskingAudioController from './pages/therapy/MaskingAudioController'
import HearingTestMainUi from './pages/hearingTest/HearingTestMainUi'
import TherapyReadyController from './pages/therapy/TherapyReadyController'
import PatientDashboardController from './pages/patient details dashboard/PatientDashboardController'
const loggedInPathElementRender = (login, allowed = [], permittedModule = [], Component, defaultRedirect, hideInPannel = false) => {

  const obj = {
      hideInPannel,
      element: Component,
  }
  if (!login) {
      obj['element'] = <Navigate replace to={'/sign-in'} />
  } else {

      let found = false
      for (let module of allowed) {
          for (let allowedModule of permittedModule) {
              if (module == allowedModule) {
                  found = true
                  break;
              }
          }
      }
      if (!found) {
          obj['hideInPannel'] = true
          obj['element'] = <NotAllowedComponent />
      }
  }
  return obj
}


const defineRoutes = (user) => {
  const allowedModules = user.data.modules ?? [1,2,3,4,5,6,7,8,9]
  const defaultRedirect = getDefaultRedirect(allowedModules)
  return ([
    {
      path: "sign-in",
      element: !user.isLoggedIn ?<SignInController />  : <Navigate replace to={defaultRedirect} />,
      hideInPannel: true

    },
    {
      path: "",
      element: user.isLoggedIn ? <Navigate replace to={defaultRedirect} /> : <Navigate replace to="/sign-in" />,
      hideInPannel: true

    },
    {
      path: "patient",
      icon: <Groups2Outlined />,
      title: "Patient",
      ...loggedInPathElementRender(user.isLoggedIn, [MODULES.DASHBOARD], allowedModules,<AppContainer ><PatientListController/></AppContainer> , defaultRedirect),
      hideInPannel: false,

    },
    {
      path: "Patient-Details/:id",
      icon: <Groups2Outlined />,
      title: "Patient Hearing Details",
      ...loggedInPathElementRender(user.isLoggedIn, [MODULES.DASHBOARD], allowedModules,<PatientHearingDetails/> , defaultRedirect),
      hideInPannel: false,

    },
    {
      path: "therapy/:id",
      icon: <Groups2Outlined />,
      title: "Therapy",
      ...loggedInPathElementRender(user.isLoggedIn, [MODULES.DASHBOARD], allowedModules,<AppContainer ><MaskingAudioController TherapyReadyController/></AppContainer> , defaultRedirect),
      hideInPannel: false,

    },
    {
      path: "therapyReady/:id",
      icon: <Groups2Outlined />,
      title: "",
      ...loggedInPathElementRender(user.isLoggedIn, [MODULES.DASHBOARD], allowedModules,<AppContainer ><TherapyReadyController/></AppContainer> , defaultRedirect),
      hideInPannel: false,

    },
    {
      path: "tinnitusTest/:id",
      icon: <Groups2Outlined />,
      title: "TinnitusTest",
      ...loggedInPathElementRender(user.isLoggedIn, [MODULES.DASHBOARD], allowedModules,<HearingTestController/> , defaultRedirect),
      hideInPannel: false,

    },
    {
      path: "users",
      icon: <Groups2Outlined />,
      title: "Users",
      ...loggedInPathElementRender(user.isLoggedIn, [MODULES.USER], allowedModules,<AppContainer ><ListController/></AppContainer> , defaultRedirect),
      hideInPannel: false,

    },
    
    {
      path: "*",
      hideInPannel: true,
      element: !user.isLoggedIn ? <Navigate replace to={"/sign-in"} /> : <PagenotFound />,
    },

  ])

}

export default defineRoutes